<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "LabelError" });
import "tailwindcss/tailwind.css";
import { t } from "svelte-i18n";
export let error = null;
export let id = void 0;
</script>

<label for = { id }>
    {#if error !== null }
        { $t(error) }
    {/if}
</label>

<style>

    label {

        color: rgba(239, 35, 59, 1);

        display: block;

        font-size: 9px;
        line-height: 10px;

        opacity: 0;
        transition: opacity 0.5s ease-in-out;
}

        label:not(:empty) {
            opacity: 1;
        }</style>